import { FC } from 'react';

import {
  EmptyState,
  EmptyStateImageVariant,
  EmptyStateVariant,
} from '../../../components/empty-state/index';
import { useLocale } from '../../../hooks/index';
import { StringKey } from '../../../lang/string-key.const';
import { CompanyFilter } from '../../../types/company.types';

const emptyStateCopy: Record<CompanyFilter, { description: StringKey; text: StringKey }> = {
  [CompanyFilter.ACTIVE]: {
    description: 'NO_ACTIVE_COMPANIES_DESCRIPTION',
    text: 'NO_ACTIVE_COMPANIES',
  },
  [CompanyFilter.INACTIVE]: {
    description: 'NO_INACTIVE_COMPANIES_DESCRIPTION',
    text: 'NO_INACTIVE_COMPANIES',
  },
};

export const NoCompaniesFilterEmptyState: FC<{ filter: CompanyFilter }> = ({ filter }) => {
  const { messagesLocale } = useLocale();
  const copy = emptyStateCopy[filter];

  return (
    <EmptyState
      colorScheme={EmptyStateVariant.BEIGE}
      description={messagesLocale[copy.description]}
      imageVariant={EmptyStateImageVariant.BRIEFCASE}
      text={messagesLocale[copy.text]}
    />
  );
};
